export default {
  methods: {
  /**
    Apply Filter is a generic method that filters a list based on the colums and filter string. The power of this method
    is that it allows us to filter based on columns without specifiying the columns. The only exception is the status.

    @param columns  an array list of objects that represent the column headers, each header must have a key 'value' to
                    represent a field on the 'obj' param. Note: This is set up from a v-data-table
    @param obj      object which will be matched with the filter
    @param filter   the filter to be applied to the object
  */
    applyFilter(columns, obj, filter) {
      // Loop through each of the headers, which in this case represent columns
      for(let i = 0; i < columns.length; i++) {

        // Get the value of the column which represents a field on the object
        let key = columns[i].value

        // Confirm that the object we are filtering on has that field and that field does not equal null
        if (obj.hasOwnProperty(key) && obj[key] !== null) {

          // Assign the field value
          let fieldVal = obj[key]

          // This is custom logic to deal with the 'status' field which is custom, I just haven't built anything generic
          // for it yet, so if we get a key that is for the status, we want to search on the message provided
          if (key === 'status') {
            fieldVal = this.$t(
              'message.dealerApplicationStatuses.' + obj.status
            )
          }

          if(key === 'lastEditDate') {
            console.log(typeof fieldVal)
          }

          // If the field is not a string, we need to make it a string, so it can be compared to the search string
          if (typeof fieldVal !== 'string') {
            fieldVal = fieldVal.toString()
          }

          // make the field val lowercase to perform a case insensitive search
          fieldVal = fieldVal.toLowerCase()

          // return immediately if found, for short circuiting
          if (fieldVal.includes(filter)) {
            return true
          }
        }
      }

      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/listMixins.js